module.exports = __webpack_public_path__ + "media/images/user/logo-de1eace5bf8b8deeef690c25df593534.png";